import { render, staticRenderFns } from "./AttendancesOnlyDesktop.vue?vue&type=template&id=22178168&"
import script from "./AttendancesOnlyDesktop.vue?vue&type=script&lang=js&"
export * from "./AttendancesOnlyDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports